module.exports = __webpack_public_path__ + "img/thumb_04.022412e7.jpg";